import React, { Component, useState, useRef } from 'react'
import { CardDeck, Row, Col, Container, Card, Button, OverlayTrigger, Popover,Overlay } from 'react-bootstrap'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react';
import { Toast } from 'primereact/toast';
import '../../css/AdvanceAdjustButtonTable.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../../css/HomeMini.css';
class AdvanceTableWithAdjustButton extends React.Component {
    constructor(props) {
        super(props);
     
        
        this.dt = React.createRef();


        this.state = {
            globalSearchBox: '',
            data: this.props.data,
            columns: this.props.columns,
            datakeyName:this.props.datakeyName,
            PageSize:10,
            AdjustdObject:[],
        };

        this.onChange = this.onChange.bind(this);
        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
        this.confirmAdjustProduct=this.confirmAdjustProduct.bind(this);
        this.sendAdjustObject=this.sendAdjustObject.bind(this);
    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.data})
    }

    onChange(e) {
        console.log(e.target.value);
        this.setState(
            { [e.target.name]: e.target.value }
        )

    }
    
    actionBodyTemplate(rowData) {
        
        return (
            <React.Fragment>
                    <a onClick={() => this.confirmAdjustProduct(rowData)}>                      
                        <FeatherIcon  icon="plus-square" size="20" />
                    </a> 
               
            </React.Fragment>
        );
    }

    async confirmAdjustProduct(Row) {
        
        await this.setState({AdjustdObject:Row});
        this.sendAdjustObject();
    }

    sendAdjustObject = () => {
        this.props.parentAdjustdObjectCallback(this.state.AdjustdObject);
        } 
    

    render() {
       
        return (
                <>
               
                       <Toast ref={(el) => this.toast = el} />
                        <div className="text-right mb-2">
                           
                           <input type="text" className="pb-2 form-control col-sm-2 col-12 pull-right" id="user-name" name="globalSearchBox" placeholder="Search..." onChange={this.onChange} />
                        </div>
                        <br></br>
                        <br></br>
                        <DataTable dataKey={this.state.datakeyName} ref={this.dt} class="Table" value={this.state.data} paginator rows={this.state.PageSize} sortMode="multiple" globalFilter={this.state.globalSearchBox} >
                            {
                                this.state.columns.map(
                                    (item, index) => (
                                         <Column field={item.MappingColomn} header={item.HeaderText} sortable></Column>
                                        )
                                    )
                            }
                            <Column body={this.actionBodyTemplate}></Column>
                        </DataTable>
                </>
            
        );
    }
}

export default AdvanceTableWithAdjustButton;


